import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

let firebaseConfig;
if (process.env.NODE_ENV === "development") {
    firebaseConfig = {
        apiKey: "AIzaSyC1-e0TRwfAdXn-PqhLUaJf0w1xDVvl8po",
        authDomain: "sedecti-homologacao.firebaseapp.com",
        databaseURL: "https://sedecti-homologacao.firebaseio.com",
        projectId: "sedecti-homologacao",
        storageBucket: "sedecti-homologacao.appspot.com",
        messagingSenderId: "24921260109",
        appId: "1:24921260109:web:3ffb2df11e97512eac5c04"
    }
} else {
    firebaseConfig = {
        apiKey: "AIzaSyDghxtYhXoPhcvHgG6gPpPVS0KAMiSgH6w",
        authDomain: "sedecti-empresas-dashboard.firebaseapp.com",
        databaseURL: "https://sedecti-empresas-dashboard.firebaseio.com",
        projectId: "sedecti-empresas-dashboard",
        storageBucket: "sedecti-empresas-dashboard.appspot.com",
        messagingSenderId: "783887766296",
        appId: "1:783887766296:web:2f9f1637b7d16bb238046d",
        measurementId: "G-NY80Y4T6QY"
    }
}

firebase.initializeApp(firebaseConfig)

export const db = firebase.firestore()
export const auth = firebase.auth()
export const storage = firebase.storage()